import React, { useState } from "react";
import { useRef } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  Button,
  TextField,
  Grid,
  withStyles,
  Divider,
} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import RateList from "../../Tables/RateList";
import LabRateList from "../../Tables/labRatelist";
import CentreRateList from "../../Tables/centreRatelist";
import { useEffect } from "react";
import {
  getCenterInfo,
  getLabCredential,
  getPackageByRatelist,
  createRateList,
  attachRateList,
  uploadRateList,
  getRateList,
  getRateListFilter,
  getTestCategory,
  updateRateList,
  getRatelistExport,
} from "../../actions/GenomicsAdminAction";

import { useHistory } from "react-router-dom";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import Autocomplete from "@material-ui/lab/Autocomplete";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from '@mui/material/Box';
import AppBar from "@material-ui/core/AppBar";
import ExportRateList from "./ExportRateList";

// import "./index.sass";
const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    table: {
      minWidth: 700,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      marginTop: "2rem",
      padding: "0.5rem 2rem 2rem 2rem",
      width: "100%",
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 40px 10px",
      minHeight: "64px",
    },
    leftContentHeader: {
      width: "50%",
      float: "left",
    },
    rightContentHeader: {
      width: "50%",
      float: "right",
      textAlign: "right",
      paddingRight: "20px",
    },
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    head: {
      textAlign: "center",
      fontWeight: "normal",
      marginBottom: "2rem",
    },
    slotContainer: {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
    },
    slot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      margin: "0.5rem",
    },
    hoveItem: {
      cursor: "pointer",
    },
    selectedSlot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(60deg, cyan, #00dfff, cyan)",
      cursor: "pointer",
      margin: "0.5rem",
    },
    chips: {
      display: "flex",
    },
    chip: {
      margin: 2,
      background: "linear-gradient(60deg, cyan, #00cfff, cyan)",
      maxWidth: "130px",
    },
    input: {
      padding: "1px",
    },
  })
);

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
  style: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface Props {
  getPackageByRatelist: any;
  packageList: any;
  getLabCredential: any;
  labCredential: any;
  getCenterInfo: any;
  centerInfo: any;
  createRateList: any;
  attachRateList: any;
  uploadRateList: any;
  uploadRatelistData: any;
  updateRateList: any;
  getRateList: any;
  rateList: any;
  getRateListFilter: any;
  rateListFilter: any;
  getTestCategory: any;
  testCategory: any;
  getRatelistExport: any;
  rateListExport: any;
  loading: any;
}
const NewRateList: React.FC<Props> = ({
  packageList,
  getPackageByRatelist,
  getCenterInfo,
  centerInfo,
  getLabCredential,
  labCredential,
  createRateList,
  attachRateList,
  uploadRateList,
  uploadRatelistData,
  updateRateList,
  getRateList,
  rateList,
  getRateListFilter,
  rateListFilter,
  getTestCategory,
  testCategory,
  getRatelistExport,
  rateListExport,
  loading,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const timer = useRef<any>(0);
  const [lab, setLab] = React.useState<any>("");
  const [labName, setLabName] = React.useState<any>("");
  const [rateListName, setRateListName] = React.useState<any>("");
  const [processingRate, setProcessingRate] = useState<any>([]);
  const [rateListUpdate, setRateListUpdate] = useState<any>("");
  const [centre, setCentre] = useState<any>("");
  const [rateListId, setRateListId] = React.useState<any>("");
  const [rateListFilterName, serRateListFilterName] = React.useState<any>("");
  const [labId, setLabId] = React.useState<any>("");
  const [rateListUploadId, setRateListUploadId] = React.useState<any>("");
  const [rateListInput, setRateListInput] = React.useState<any>("");
  const [file, setFile] = React.useState<any>("");
  const [updateId, setUpdateId] = useState<any>("");
  const [centreFilter, setCentreFilter] = useState<any>("");
  const [centreFilterDef, setCentreFilterDef] = useState<any>("");
  const [centreName, setCentreName] = useState<any>("");
  const [labFilter, setLabFilter] = React.useState<any>("");
  const [labFilterName, setLabFilterName] = React.useState<any>("");
  const [packageId, setPackageId] = React.useState<any>("");
  const [packageFilt, setPackageFilt] = React.useState<any>("");
  const [rateListIdProp, setRateListIdProp] = React.useState<any>("");
  const [testCodeProp, setTestCodeProp] = React.useState<any>("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [editButton, setEditButton] = useState<boolean>(false);
  const [reset, setReset] = useState<boolean>(false);
  const [rateListIdName, setRateListIdName] = useState<any>(false);
  const [hospitalName, setHospitalName] = useState<any>(false);
  useEffect(() => {
    getCenterInfo();
    getLabCredential();

    getRateList();
    getTestCategory();
  }, []);
  useEffect(() => {
    getRateList(`assigned_lab=${lab}`);
  }, [lab]);
  useEffect(() => {
    if (centreName !== "") {
      getRateList(
        `assigned_lab=${labFilter}&center=${centreFilter}&name=${rateListFilterName}`
      );
    } else {
      getRateList(`assigned_lab=${labFilter}&name=${rateListFilterName}`);
    }
  }, [labFilter, centreFilter, rateListFilterName, centreName]);
  useEffect(() => {
    if (rateListUpdate !== "") {
      setEditButton(true);
      setUpdateId(rateListUpdate?.id);
      setLab(rateListUpdate?.assigned_lab?.id);
      setLabName(rateListUpdate?.assigned_lab?.name);
      setRateListName(rateListUpdate?.name);

      if (rateListUpdate.processing_rate.length > 0) {
        const newObj: any = [];
        rateListUpdate.processing_rate.map((obj: any) => {
          newObj.push({
            test_category: obj.test_category.id,
            test_category_name: obj.test_category.name,
            rate_percentage: obj.rate_percentage,
          });
        });
        setProcessingRate(newObj);
        // console.log(newObj);
      }
    }
  }, [rateListUpdate]);
  useEffect(() => {
    if (testCategory.length > 0) {
      const newObj: any = [];
      testCategory.map((obj: any) => {
        newObj.push({
          test_category: obj.id,
          test_category_name: obj.name,
          rate_percentage: "",
        });
      });
      setProcessingRate(newObj);
    }
  }, [testCategory]);

  const handleReset = () => {
    history.push("/dashboard/gnadmin/new_rate_list");
    setReset(false);
  };

const handleResetcenter = ()=>{
  setRateListId("");
  setCentre("");
  setRateListIdName("");
  setHospitalName("");
   
   };

  const handleResetTable = () => {
    setPackageId("");
    setLabFilter("");
    setLabFilterName("");
    setCentreName("");
    setCentreFilter("");
    setRateListId("");
    serRateListFilterName("");
    setRateListIdProp("");
    setPackageFilt("");
  };
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };
  const createNewRatelist = async (e: any) => {
    e.preventDefault();
    const data: any = {
      name: rateListName,
      assigned_lab: Number(lab),
      processing_rate: processingRate,
      org_type:"genomics",
    };
    if (editButton) {
      delete data.assigned_lab;
      delete data.processing_rate;
      await updateRateList(data, updateId);
    } else {
      await createRateList(data);
    }
    setEditButton(false);
    handleReset();
  };
  const attachRatelistSave = async (e: any) => {
    e.preventDefault();
    const data: any = {
      center: centre,
      ratelist: Number(rateListId),
    };
    if (editButton) {
      await attachRateList(data, updateId);
    } else {
      await attachRateList(data);
    }
    setEditButton(false);
    handleReset();
  };
  const fileSelectedHandler = (e: React.ChangeEvent<{ files: any }>) => {
    setFile(e.target.files[0]);
  };
  const uploadRatelistSave = async (e: any) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("file", file);

    await uploadRateList(formData, rateListUploadId);
    setReset(true);
    setLabId("");
    setRateListUploadId("");
    setRateListInput("");
  };
  // console.log(file, "f");
  useEffect(() => {
    getRateListFilter(labId, rateListInput);
  }, [labId, rateListInput]);

  const filterHandler = () => {
    setRateListIdProp(rateListId);
    setTestCodeProp(packageId);
  };
  const handleExport = () => {
    getRatelistExport(rateListUploadId);
  };
  // useEffect(() => {
  //   window.open("data:text/csv;charset=utf-8," + escape(rateListExport))
  // }, [rateListExport])
  useEffect(() => {
    if (
      rateListId !== "" &&
      centreFilter === "" &&
      centerInfo.results &&
      centerInfo.results.length > 0
    ) {
      setCentreName(centerInfo.results[0].name);
      setCentreFilter(centerInfo.results[0].id);
    }
  }, [centerInfo]);

  return (
    <Grid container spacing={2} style={{ marginTop: 50 }}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          <Tab label="Create Rate List" {...a11yProps(0)} />
          <Tab label="Tag Rate List to Hospital/Doctor" {...a11yProps(1)} />
          <Tab label="Service Rate Caegory Table" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      {/* create rate List */}
      <TabPanel style={{ width: "100%" }} value={value} index={0}>
        <form onSubmit={createNewRatelist} style={{ width: "100%" }}>
          <Grid container>
            <Grid container spacing={2} xs={12} md={5}>
              <Grid item xs={12} sm={6} md={6}>
                <Autocomplete
                  onChange={(event, newValue) => {
                    if (newValue) {
                      let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                      setLab(obj.id);
                    }
                  }}
                  disabled={editButton === true}
                  inputValue={labName}
                  onInputChange={(event, newInputValue) => {
                    setLabName(newInputValue);
                    getLabCredential(`?name=${newInputValue}`);
                    if (newInputValue.length === 0) {
                      setLab("");
                    }
                  }}
                  options={labCredential.results || []}
                  freeSolo
                  blurOnSelect
                  aria-required
                  getOptionLabel={(option: any) => `${option?.name}`}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Lab"
                      variant="outlined"
                      fullWidth
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <TextField
                  label="Service Rate Category"
                  variant="outlined"
                  fullWidth
                  required
                  value={rateListName}
                  onChange={(e) => setRateListName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <TableContainer style={{ height: 300 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">Discount Category</TableCell>
                        <TableCell align="center">
                          Discount Percentage
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {processingRate.length > 0 &&
                        processingRate.map((val: any, index: any) => (
                          <TableRow>
                            <TableCell align="center">
                              {val.test_category_name}
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                required
                                disabled={editButton === true}
                                key={val.rate_percentage}
                                defaultValue={val.rate_percentage}
                                variant="outlined"
                                size="small"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      %
                                    </InputAdornment>
                                  ),
                                  inputProps: { min: 0, max: 100 },
                                }}
                                type={"number"}
                                onChange={(e) =>
                                (processingRate[index].rate_percentage =
                                  Number(e.target.value))
                                }
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Button
                  color="primary"
                  variant="contained"
                  fullWidth
                  type="submit"
                  style={{ height: "55px" }}
                >
                  {editButton ? "Update" : "Create"}
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Button
                  color="secondary"
                  variant="contained"
                  fullWidth
                  onClick={handleReset}
                  style={{ height: "55px" }}
                >
                  reset
                </Button>
              </Grid>
            </Grid>

            <Grid container spacing={2} xs={12} md={1}>
              <Divider
                orientation="vertical"
                flexItem
                style={{ margin: "0px auto" }}
              />
            </Grid>
            <Grid container spacing={2} xs={12} md={6}>
              <LabRateList
                getRateList={getRateList}
                rateList={rateList}
                setRateListUpdate={setRateListUpdate}
              />
            </Grid>
          </Grid>
        </form>
        <Grid item>
          <Divider
            style={{ marginTop: 35, marginLeft: 150, marginBottom: -15 }}
          />
        </Grid>
        <Grid container>
          <h4>Special Rate</h4>
          <form onSubmit={uploadRatelistSave} style={{ width: "100%" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={2}>
                <Autocomplete
                  key={String(reset)}
                  id="serviceRateCate"
                  onChange={(event, newValue) => {
                    if (newValue) {
                      let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                      setLabId(obj.id);
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    getLabCredential(`?name=${newInputValue}`);
                    if (newInputValue.length === 0) {
                      setLabId("");
                    }
                  }}
                  options={labCredential.results || []}
                  freeSolo
                  disableClearable
                  blurOnSelect
                  aria-required
                  getOptionLabel={(option: any) => `${option?.name}`}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Lab"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Autocomplete
                  id="serviceRateCate"
                  onChange={(event, newValue) => {
                    if (newValue) {
                      let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                      setRateListUploadId(obj.id);
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    setRateListInput(newInputValue);
                  }}
                  inputValue={rateListInput}
                  loading={loading}
                  options={rateListFilter.results || []}
                  freeSolo
                  blurOnSelect
                  aria-required
                  disableClearable
                  getOptionLabel={(option: any) => `${option?.name}`}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Service Rate Category"
                      variant="outlined"
                      fullWidth
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <input
                  type="file"
                  onChange={(e: any) => setFile(e.target.files[0])}
                  accept=".csv"
                />
                <sub>*Upload .csv (Code,SpecialPrice,SpecialMrp)</sub>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Button
                  color="primary"
                  variant="contained"
                  fullWidth
                  type="submit"
                  style={{ height: "55px" }}
                >
                  Upload
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Button
                  color="secondary"
                  variant="contained"
                  fullWidth
                  style={{ height: "55px" }}
                  onClick={handleExport}
                  disabled={rateListUploadId === ""}
                >
                  Export
                </Button>
              </Grid>
            </Grid>
          </form>
          <div>
            {reset && uploadRatelistData?.error !== undefined
              ? JSON.stringify(uploadRatelistData.error).replace(
                /"|{|}|[|]/g,
                ""
              )
              : ""}
          </div>
        </Grid>
        <ExportRateList rateListExport={rateListExport} loading={loading} />
      </TabPanel>
      {/* tag centre to ratelist */}
      <TabPanel style={{ width: "100%" }} value={value} index={1}>
        <form onSubmit={attachRatelistSave} style={{ width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              id="center_type"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  setCentre(obj.id);
                }
              }}
              freeSolo
              blurOnSelect
              options={centerInfo?.results}
              disableCloseOnSelect
              getOptionLabel={(option: any) =>
                (option?.display_name === null
                  ? option?.name
                  : option?.display_name) +
                "(" +
                option?.center_code +
                ")"
              }
              onInputChange={(event, newInputValue) => {
                getCenterInfo(`&name_or_code=${newInputValue}`);
                setHospitalName(newInputValue)

              }}
              inputValue={hospitalName}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Hospital/Doctor"
                  variant="outlined"
                  fullWidth
                  required
                />
              )}
            />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                id="serviceRateCate"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setRateListId(obj.id);
                  }
                }}
                onInputChange={(event, newInputValue) => {
                  setRateListIdName(newInputValue)
                  getRateList(`?name=${newInputValue}`);
                }}
                inputValue={rateListIdName}
                options={rateList.results || []}
                freeSolo
                blurOnSelect
                aria-required
                getOptionLabel={(option: any) => `${option?.name}`}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Rate List"
                    variant="outlined"
                    fullWidth
                    required
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <Button
                color="primary"
                variant="contained"
                fullWidth
                type="submit"
                style={{ height: "100%" }}
              >
                save
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Button
                color="secondary"
                variant="contained"
                fullWidth
                onClick={handleResetcenter}
                style={{ height: "100%" }}
              >
                reset
              </Button>
            </Grid>
          </Grid>
        </form>
        <CentreRateList centreId={centre} rateListId={rateListId} />
      </TabPanel>
      {/* filter */}
      <TabPanel style={{ width: "100%" }} value={value} index={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={2}>
            <Autocomplete
              id="serviceRateCate"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  setCentreFilter("");
                  setRateListId(obj.id);

                  getCenterInfo(`&rate_list=${obj.id}`);
                }
              }}
              options={rateList.results || []}
              freeSolo
              blurOnSelect
              inputValue={rateListFilterName}
              onInputChange={(event, newInputValue) => {
                serRateListFilterName(newInputValue);
                if (newInputValue === "") {
                  setRateListId("");
                }
              }}
              // disabled={centreFilter === ""}
              getOptionLabel={(option: any) => `${option?.name}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Rate List Name"
                  variant="outlined"
                  fullWidth
                  required
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Autocomplete
              id="center"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  setCentreFilter(obj.id);
                  setRateListId(obj.ratelist[0]?.id);
                  serRateListFilterName(obj.ratelist[0]?.name);
                }
              }}
              freeSolo
              blurOnSelect
              options={centerInfo?.results || []}
              disableCloseOnSelect
              getOptionLabel={(option: any) =>
                option.id !== ""
                  ? (option?.display_name === null
                    ? option?.name
                    : option?.display_name) +
                  "(" +
                  option?.center_code +
                  ")"
                  : ""
              }
              onInputChange={(event, newInputValue) => {
                getCenterInfo(
                  `&rate_list=${rateListId}&name_or_code=${newInputValue}`
                );
                setCentreName(newInputValue);
                // if (newInputValue === "") {
                //   setCentreFilter("");
                // }
              }}
              inputValue={centreName}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Hospital/Doctor"
                  variant="outlined"
                  fullWidth
                  required
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Autocomplete
              id="lab"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  setLabFilter(obj.id);
                }
              }}
              options={labCredential.results || []}
              freeSolo
              blurOnSelect
              inputValue={labFilterName}
              onInputChange={(event, newInputValue) => {
                getLabCredential(`?name=${newInputValue}`);
                setLabFilterName(newInputValue);
                if (newInputValue === "") {
                  setLabFilter("");
                }
              }}
              getOptionLabel={(option: any) => `${option?.name}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Lab"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Autocomplete
              id="customerPackage"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                  setPackageId(obj?.code);
                }
              }}
              disabled={centreFilter === ""}
              options={packageList.results || []}
              freeSolo
              disableCloseOnSelect
              onInputChange={(event, newInputValue) => {
                setTimeout(
                  getPackageByRatelist(centreFilter, newInputValue),
                  1000
                );
                setPackageFilt(newInputValue);
                if (newInputValue === "") {
                  setPackageId("");
                }
              }}
              inputValue={packageFilt}
              getOptionLabel={(option: any) => {
                return option?.name + "(" + option?.code + ")";
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Package"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Button
              color="secondary"
              variant="contained"
              fullWidth
              onClick={filterHandler}
              style={{ height: "100%" }}
            >
              filter
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} md={1}>
            <Button
              color="primary"
              variant="contained"
              fullWidth
              onClick={handleResetTable}
              style={{ height: "100%" }}
            >
              reset
            </Button>
          </Grid>
        </Grid>
        <Grid container>
          <RateList RateListId={rateListIdProp} testId={testCodeProp} />
        </Grid>
      </TabPanel>
    </Grid>
  );
};
const mapStateToProps = (state: any) => ({
  loading: state.GenomicsAdminReducer.loading,
  rateList: state.GenomicsAdminReducer.rateList,
  rateListFilter: state.GenomicsAdminReducer.rateListFilter,
  centerInfo: state.GenomicsAdminReducer.centerInfo,
  labCredential: state.GenomicsAdminReducer.labCredential,
  packageList: state.GenomicsAdminReducer.packageList,
  testCategory: state.GenomicsAdminReducer.testCategory,
  rateListExport: state.GenomicsAdminReducer.rateListExport,
  uploadRatelistData: state.GenomicsAdminReducer.uploadRatelistData,
});
export default connect(mapStateToProps, {
  getCenterInfo,
  getLabCredential,
  getPackageByRatelist,
  createRateList,
  attachRateList,
  uploadRateList,
  getRateList,
  getRateListFilter,
  getTestCategory,
  updateRateList,
  getRatelistExport,
})(NewRateList);
